module.exports = __webpack_public_path__ + "static/looppredesign-605e52fc515b8db6fe975b5fdbe29bc9.png";